import React, { useState, useEffect } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import TabPanel from "../../../components/TabPanel";
import Circle from "../../../components/appLoading/circle";
import { set } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import { Box, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

function Custon({ value }) {
  const { profil } = useData();

  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [groupBy, setGroupBy] = useState("date");

  const [startDate, handleStartDateChange] = useState(
    set(new Date(), {
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    })
  );

  const [endDate, handleEndDateChange] = useState(
    set(new Date(), {
      hours: 47,
      minutes: 59,
      seconds: 59,
      milliseconds: 999,
    })
  );

  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getPeriodicTransaksiSeller");
      const data = {
        user_id: profil?.id,
        start_date: startDate.toISOString().substring(0, 10),
        end_date: endDate.toISOString().substring(0, 10),
      };
      const res = await func(data);

      setData(res?.data ?? []);
      setOriginalData(res?.data ?? []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, [startDate, endDate]);

  useEffect(() => {

    function groupAndSumData() {
      const groupedAndSummedData = {};
    
      originalData.forEach((item) => {
        
        const docDate = (() => {
          const dateParts = item.document_date.split('-');

          if (groupBy === 'month') return `${dateParts[0]}-${dateParts[1]}`;
          if (groupBy === 'year') return dateParts[0];

          return item.document_date;
        })();
    
        if (!groupedAndSummedData[docDate]) {
          groupedAndSummedData[docDate] = {
            document_date: docDate,
            total_komisi: 0,
            total_sales: 0
          };
        }
    
        groupedAndSummedData[docDate].total_komisi += item.total_komisi;
        groupedAndSummedData[docDate].total_sales += item.total_sales;
      });
    
      return Object.values(groupedAndSummedData);
    }

    setData(groupAndSumData());

  }, [originalData, groupBy]);


  const Data = () => {
    return (
      <>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="document_date" />
            <YAxis />
            <Tooltip
              formatter={(value) => new Intl.NumberFormat("en").format(value)}
            />
            <Legend />
            <Bar dataKey="total_komisi" fill="#8884d8">
              <LabelList
                dataKey="total_komisi"
                position="inside"
                formatter={(value) => new Intl.NumberFormat("en").format(value)}
              />
            </Bar>
            <Bar dataKey="total_sales" fill="#82ca9d">
              <LabelList
                dataKey="total_sales"
                position="inside"
                formatter={(value) => new Intl.NumberFormat("en").format(value)}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </>
    );
  };

  return (
    <TabPanel value={value} index="custom">
      <Box display="flex" flexWrap="wrap" justifyContent="space-between" style={{ gap: 4 }}>

        <Box display="flex" alignItems="center">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              margin="normal"
              style={{
                marginRight: '.5rem'
              }}
              id="date-picker-inline"
              label="Start Date"
              value={startDate}
              onChange={handleStartDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="End Date"
              value={endDate}
              onChange={handleEndDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
        </Box>

        <Box display="flex" alignItems="center">
          <FormControl variant="outlined" margin="normal" style={{ minWidth: 120 }}>
            <InputLabel>
              Group By
            </InputLabel>
            <Select
              id="group_by"
              name="group_by"
              label="group_by"
              variant="outlined"
              value={groupBy}
              onChange={(e) => setGroupBy(e.target.value)}
            >
              <MenuItem value="date">Tanggal</MenuItem>
              <MenuItem value="month">Bulan</MenuItem>
              <MenuItem value="year">Tahun</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      
      {loading ? <Circle size={25} /> : <Data />}
    </TabPanel>
  );
}

export default Custon;
